export const mediaLibrary = {
  dragDropFile:
    "https://ik.imgkit.net/ikmedia/site_graphics/videos/Drag_and_drop_interface_D5vN0PtFN.mp4",
  copyURL:
    "https://ik.imgkit.net/ikmedia/site_graphics/videos/Ready_To_Use_URL_DQcnIfU4YI.mp4",
  searchFile:
    "https://ik.imgkit.net/ikmedia/search-advanced_-rU-_iICfy.mp4",
  addTags:
    "https://ik.imgkit.net/ikmedia/site_graphics/videos/Asset_Tagging_r0mOLIe6Z.mp4",
  bulkOperaton:
    "https://ik.imgkit.net/ikmedia/site_graphics/videos/Bulk_Operations_quxS7rv-MZ.mp4",
  folderManagement:
    "https://ik.imgkit.net/ikmedia/site_graphics/videos/Folder_management_DeVrQGnth3.mp4",
  importToCloud:
    "https://ik.imgkit.net/ikmedia/use_cases/videos/Second_Animation_jv2VmjLka.mp4",
  waterMark:
    "https://ik.imgkit.net/ikmedia/use_cases/videos/Image_Watermark_A94TCb_qU.mp4",
  assetTagging: "https://ik.imgkit.net/ikmedia/site_graphics/videos/Auto_tags.mp4",
  customMetadata: "https://ik.imgkit.net/ikmedia/site_graphics/videos/Custom_Metadata.mp4",
  imageEditor: "https://ik.imgkit.net/ikmedia/site_graphics/videos/Edit_Image.mp4",
  backgroundRemover: "https://ik.imgkit.net/ikmedia/site_graphics/videos/Remove_bg.mp4",
}

export const homePage = {
  main1:
    "https://ik.imgkit.net/ikmedia/site_graphics/hero_-_1_2x_0_jb9IhWf.png",
  main2:
    "https://ik.imgkit.net/ikmedia/site_graphics/hero_-_2_2x__0kVCJHIz-.png",
}

export const commonUrlEndpoint = "https://ik.imgkit.net/ikmedia"

export const miniSites = {
  ecommerceProductPage: "/red_dress_woman.jpeg",
  newsSite: ["/news_site_woman.jpg", "white-canvas.png"],
  personalizedSection: {
    banner: {
      desktop: "/accessories_banner.jpg",
      mobile: "/shop_banner_small.jpg",
    },
    withHoodieMan: "/hoodie_man_banner.png",
    whiteHoodiePortrit: "hoodie_white.png",
    pinkHoodieBoy: "/hoodie_pink.png",
    pathToOverlayImage: "use_cases/icons/websonic_3x_fWL5pBAh1n.png",
  },
  contentAwareSmartCrop: {
    object: "/perfume_photo.jpg",
    face: "/photo_woman.jpg",
  },
  imageOptimization: {
    bag: "/messenger_bag.jpg",
  },
  responsiveImages: {
    srcSet:
      "https://ik.imgkit.net/ikmedia/use_cases/videos/srcset_animation.mp4",
    pictureElement:
      "https://ik.imgkit.net/ikmedia/use_cases/videos/picture_element.mp4",
  },
  thumbnailCreation: {
    baloon: "/blue_balloon.jpg"
  },
  secureFileAccess: {
    wallpaper: "/stock_photo_boats.jpg",
    nature: "/stock_photo_tree.jpg",
    architecture: "/stock_photo_building.jpg"
  }
}

const waterMarkPath = "stock_photos_watermark.png";
const commonWaterMarkTr = [{
  "width": 368,
  "height": 216
}, {
  raw: `l-image,i-${waterMarkPath},l-end`
}];

export const useCasesTrArr = {
  newsSite: {
    mainImage: {
      desktop: [
        { width: 532, height: 300 },
        {
          raw: "l-text,i-ImageKit%20can%20help%20you%20manipulate%20images%20in%20real-time,pa-0_5_0_10,ia-left,ff-PlayfairDisplay-Bold.ttf,co-FFFFFF,bg-00000050,fs-32,w-532,lx-10,ly-N0,l-end",
        },
      ],
      mobile: [
        { width: 279, height: 256 },
        {
          raw: "l-text,i-ImageKit%20can%20help%20you%20manipulate%20images%20in%20real-time,w-279,pa-0_5_0_10,ia-left,ff-PlayfairDisplay-Bold.ttf,co-FFFFFF,bg-00000050,fs-20,lx-10,ly-N0,l-end",
        },
      ],
    },
    contrast: [
      {
        height: "48",
        width: "80",
        effectContrast: "e-contrast",
      },
    ],
    blur: [
      {
        height: "48",
        width: "80",
        blur: "3",
      },
    ],
    backgroundColorOpacity: [
      {
        raw: "l-image,i-ik_canvas,bg-B3030020,h-48,w-80,l-end",
      },
    ],
    border: [
      {
        height: "48",
        width: "80",
        border: "3_2F2F2F",
      },
    ],
    twoImagesCombined: [
      {
        height: "96",
        width: "158",
      },
      {
        raw: "l-image,i-news_site_woman.jpg,h-92,w-76,b-2_CCCCCC,lfo-left,l-end",
      },
      {
        raw: "l-image,i-news_site_woman.jpg,h-92,w-76,b-2_CCCCCC,lfo-right,fo-face,l-end",
      },
    ],
    sharpFaceCrop: [
      {
        height: "96",
        width: "158",
        effectSharpen: "1",
        fo: "face",
      },
    ],
    customFontWatermark: [
      {
        height: "96",
        width: "158",
      },
      {
        raw: "l-text,i-THE%20LATEST%20NEWS,pa-3_5_3_5,co-FFFFFF65,bg-00000020,ff-PlayfairDisplay-Bold.ttf,l-end"
      },
    ],
  },
  contentAwareSmartCrop: {
    object: {
      centreCropped: [
        {
          width: 250,
          height: 230,
        },
      ],
      smartCropped: [
        {
          width: 250,
          height: 230,
          focus: "auto",
        },
      ],
    },
    face: {
      faceCropped: [
        {
          width: 250,
          height: 250,
          focus: "face",
        },
      ],
      smartCropped: [
        {
          width: 250,
          height: 250,
          focus: "auto",
        },
      ],
    },
  },
  personalizedSection: {
    banner: {
      desktop: [
        {
          width: 1200,
          height: 400,

        },
        {
          raw: "l-image,i-ik_canvas,bg-F8F8F6,h-176,w-234,r-88,lx-753,ly-165,l-end",
        },
        {
          raw: "l-text,i-HI%20JOHN,ff-PlayfairDisplay-Bold.ttf,co-0450D5,fs-24,lx-850,ly-120,l-end",
        },
        {
          raw: "l-text,i-EPIC%20FASHION,ff-PlayfairDisplay-Bold.ttf,fs-36,lx-850,ly-158,l-end",
        },
        {
          raw: "l-text,i-SALE,ff-PlayfairDisplay-Bold.ttf,fs-104,lx-850,ly-190,l-end",
        },
        {
          raw: "l-text,i-2%20DAYS%20TO%20GO,ff-PlayfairDisplay-Bold.ttf,fs-38,lx-850,ly-294,l-end",
        }
      ],
      mobile: [
        {
          width: 327,
          height: 401,
        },
        {
          raw: "l-image,i-ik_canvas,bg-F9F9F9,h-80,w-100,r-50,lx-122,ly-184,l-end",
        },
        {
          raw: "l-image,i-ik_canvas,bg-F6F6F6,h-187,w-185,lfo-bottom_right,l-end",
        },
        {
          raw: "l-text,i-HI%20JOHN,ff-PlayfairDisplay-Bold.ttf,co-0450D5,fs-18,lx-127,ly-210,l-end",
        },
        {
          raw: "l-text,i-EPIC%20FASHION,ff-PlayfairDisplay-Bold.ttf,fs-25,lx-127,ly-246,l-end",
        },
        {
          raw: "l-text,i-SALE,ff-PlayfairDisplay-Bold.ttf,fs-72,lx-127,ly-274,l-end",
        },
        {
          raw: "l-text,i-2%20DAYS%20TO%20GO,ff-PlayfairDisplay-Bold.ttf,fs-26,lx-127,ly-341,l-end",
        },
      ],
    },
    ecommerceListing: {
      image1: [
        {
          width: "394",
          height: "540",
          raw: "l-text,i-15%25%20OFF,co-FFFFFF,bg-EF6823,r-4,pa-8_8,fs-30,lx-10,ly-10,tg-b,l-end",
        },
      ],
      image2: [
        { width: "394", height: "540" },
        {
          raw: "l-text,i-XL,co-FFFFFF,bg-000000,r-4,pa-4_10,fs-30,lx-10,ly-N10,l-end",
        },
        {
          raw: "l-image,i-use_cases@@overlay_hoodie_2x.png,h-150,lx-10,ly-10,l-end",
        },
      ],
      image3: [
        {
          width: "394",
          height: "540",
          raw: "l-text,i-49%25%20OFF,co-FFFFFF,bg-EF6823,r-4,pa-8_8,fs-30,lx-10,ly-10,tg-b,l-end",
        },
      ],
      image4: [
        {
          width: "394",
          height: "540",
        },
        {
          raw: "l-image,i-yellow_mark.png,h-100,lx-N10,ly-0,t-false,l-end",
        },
        {
          raw: "l-text,i-MOST%20POPULAR,co-FFFFFF,w-150,pa-10_0,fs-25,lx-N20,ly-0,tg-b,l-end",
        },
      ],
      image5: [
        {
          width: "394",
          height: "540",
          raw: "l-text,i-28%25%20OFF,co-FFFFFF,bg-EF6823,r-4,pa-8_8,fs-30,lx-10,ly-10,tg-b,l-end",
        },
      ],
      image6: [
        { width: "394", height: "540" },
        {
          raw: "l-text,i-M,co-FFFFFF,bg-000000,r-4,pa-4_10,fs-30,lx-10,ly-N10,l-end",
        },
        {
          raw: "l-image,i-use_cases@@overlay_hoodie_2x.png,h-150,lx-10,ly-10,l-end",
        },
      ],
      image7: [
        {
          width: "394",
          height: "540",
          raw: "l-text,i-49%25%20OFF,co-FFFFFF,bg-EF6823,r-4,pa-8_8,fs-30,lx-10,ly-10,tg-b,l-end",
        },
      ],
      image8: [
        {
          width: "394",
          height: "540",
          raw: "l-text,i-28%25%20OFF,co-FFFFFF,bg-EF6823,r-4,pa-8_8,fs-30,lx-10,ly-10,tg-b,l-end",
        },
      ],
      image9: [
        {
          width: "394",
          height: "540",
          raw: "l-text,i-15%25%20OFF,co-FFFFFF,bg-EF6823,r-4,pa-8_8,fs-30,lx-10,ly-10,tg-b,l-end",
        },
      ],
      image10: [
        {
          width: "394",
          height: "540",
        },
        {
          raw: "l-image,i-yellow_mark.png,h-100,lx-N10,ly-0,t-false,l-end",
        },
        {
          raw: "l-text,i-MOST%20POPULAR,co-FFFFFF,w-150,pa-10_0,fs-25,lx-N20,ly-0,tg-b,l-end",
        }
      ],
    },
    ecommerceProduct: {
      desktop: [
        [{ width: "338", height: "451" }],
        [{ named: "dress_top_focussed" }, { width: "338", height: "451" }],
        [
          {
            width: "1200",
            height: "1500",
            cropMode: "extract",
            focus: "bottom",
          },
          { width: "338", height: "451" }
        ],
      ],
      mobile: [
        [{ width: "930", height: "946" }],
        [{ named: "dress_top_focussed" }, { width: "930", height: "946" }],
        [
          {
            width: "1200",
            height: "1500",
            cropMode: "extract",
            focus: "bottom",
          },
          { width: "930", height: "946" }
        ],
      ],
      thumbnail: [
        [{ width: "36", height: "48" }],
        [{ named: "dress_top_focussed" }, { width: "36", height: "48" }],
        [
          {
            width: "1200",
            height: "1500",
            cropMode: "extract",
            focus: "bottom",
          },
          { width: "36", height: "48" }
        ],
      ],
    },
  },
  imageOptimization: {
    originalImage: [{
      format: 'origin',
      quality: 100
    }],
    saveDataOn: [{
      format: 'webp',
      quality: 60
    }],
    saveDataOff: [{
      format: 'webp',
      quality: 100
    }]
  },
  secureFileAccess: {
    wallpaper: commonWaterMarkTr,
    nature: commonWaterMarkTr,
    architecture: commonWaterMarkTr
  }
}

//These urls should be consistent with there counterparts in above usecase object as that transformation will be used to show in code block
export const secureURLs = {
  wallpaper: "https://ik.imgkit.net/ikmedia/tr:w-368,h-216:l-image,i-stock_photos_watermark.png,l-end/stock_photo_boats.jpg?ik-s=0bf176c0248298d3d8105a94e501466b6155491e",
  nature: "https://ik.imgkit.net/ikmedia/tr:w-368,h-216:l-image,i-stock_photos_watermark.png,l-end/stock_photo_tree.jpg?ik-s=14d2e8c08eca04e7065f49c887f9682241b0c7fc",
  architecture: "https://ik.imgkit.net/ikmedia/tr:w-368,h-216:l-image,i-stock_photos_watermark.png,l-end/stock_photo_building.jpg?ik-s=49b9bfb9b052813c70160940621ef09a62790060"
}
